<template>
  <div>
    <div class="content-form">
      <h3 class="subtitle">BANK & BENEFICIARY INFORMATION</h3>
      <div class="form-row form-split routing-number-validate">
        <!--<form-field-text v-model="form.bank_name" label="Bank Name" :validator="v.bank_name" required />-->
        <form-field-text v-model="form.swift" label="Bank SWIFT Code" :validator="v.swift" required />
        <button :disabled="!showSwiftBtn" class="btn btn-success show-btn" @click="validateSwift()"><i class="el-icon-search" /> Validate</button>
      </div>
      <p class="bank-name"><template v-if="bankSwiftInfo">{{ bankSwiftInfo['bankName'] }},</template><template v-if="bankSwiftAddress">{{ bankSwiftAddress['line1'] }},  {{ bankSwiftAddress['line2'] }}</template>, <template v-if="bankSwiftAddress">{{ bankSwiftAddress['city'] }}, {{ bankSwiftAddress['state'] }}, {{ bankSwiftAddress['postalCode'] }}, {{ bankSwiftAddress['country'] }}</template>&nbsp;</p>
      <div class="form-row form-split">
        <form-field-select v-model="form.account_type" label="Account Type" :validator="v.account_type" :options="accountOptions" required />
        <form-field-text v-model="form.account_name" label="Account Name" :validator="v.account_name" required />
      </div>
      <div class="form-row form-fullw">
        <div>
          <form-field-text v-model="form.account_number" label="Account Number" :validator="v.account_number" required />
          <!--<span class="error-message account-number-alert">Numbers and Letters Accepted</span>-->
        </div>
      </div>
      <br/>
      <br/>
      <div class="use_intermediary_bank_div">
        <h3 class="subtitle">INTERMEDIARY BANK INFORMATION</h3>
        <div class="center-checkbox">
          <input v-model="form.use_intermediary_bank" type="checkbox" id="use_intermediary_bank" disabled>
          <label for="use_intermediary_bank">Use Intermediary Bank <span class="error-message">*Required</span></label>
        </div>
      </div>
      <template v-if="form.use_intermediary_bank">
        <div class="form-row form-split routing-number-validate">
          <!--<form-field-text v-model="form.intermediary_bank_name" label="Intermediary Bank Name" :validator="v.intermediary_bank_name" required />-->
          <form-field-text v-model="form.intermediary_bank_routing_number" label="Intermediary Bank Routing Number" :validator="v.intermediary_bank_routing_number" required />
          <button :disabled="!showBtn" class="btn btn-success show-btn" @click="validateRoutingNumber()"><i class="el-icon-search" /> Validate</button>
        </div>
        <p class="bank-name"><template v-if="bankInfo">{{ bankInfo.name }}, {{bankInfo.phone}}, {{ bankInfo.street }}, {{ bankInfo.city }}, {{ bankInfo.state}}, {{ bankInfo.zip }}</template></p>
        <div class="form-row form-split">
          <form-field-text v-model="form.intermediary_bank_swift_code" label="Intermediary Bank SWIFT Code" :validator="v.intermediary_bank_swift_code" required />
          <form-field-text v-model="form.intermediary_bank_reference" label="Intermediary Bank Reference" :validator="v.intermediary_bank_reference" required />
        </div>
        <!--<h3 class="subtitle">INTERMEDIARY BANK ADDRESS</h3>
        <address-form v-model="form.intermediary_address" :v="v.intermediary_address" />-->
      </template>

      <h3 class="subtitle">BENEFICIARY ADDRESS</h3>
      <div class="form-row form-split">
        <form-field-text v-model="form.iban" label="IBAN" :validator="v.iban" />
      </div>
      <address-dom-form v-model="form" :v="v" />
    </div>
    <popup :open.sync="showConfirm">
      <div class="popup-header">
        <h3>Intermediary Bank Confirmation</h3>
      </div>
      <div class="scrollable">
        <div class="content-form bank-info">
          <p v-if="bankError">Error searching Banks. {{ bankErrorMsg }}</p>
          <p v-if="notFound">Intermediary Bank not found. Please check information and try again.</p>
          <template v-if="bankInfo">
            <div class="form-row form-split">
              <label>
                <b>Routing Number: </b>
              </label>
              <label>
                {{ bankInfo.routingNumber }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Name: </b>
              </label>
              <label>
                {{ bankInfo.name }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Address: </b>
              </label>
              <label>
                {{ bankInfo.street }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Address 2: </b>
              </label>
              <label v-if="bankAddress">
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>City: </b>
              </label>
              <label>
                {{ bankInfo.city }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>State/Province: </b>
              </label>
              <label>
                {{ bankInfo.state }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Postal/Zip: </b>
              </label>
              <label>
                {{ bankInfo.zip }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Country: </b>
              </label>
              <label>
              
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Phone: </b>
              </label>
              <label>
                {{ bankInfo.phone }}
              </label>
            </div>
          </template>
        </div>
        <div class="buttons">
          <template v-if="notFound || bankError">
            <button class="second" @click="showConfirm = false">Close</button>
          </template>
          <template v-else>
            <button class="main" @click="confirmIntermediary()">Confirm</button>
            <button class="second" @click="showConfirm = false">Cancel</button>
          </template>
        </div>
      </div>
    </popup>
    <popup :open.sync="showSwiftConfirm">
      <div class="popup-header">
        <h3>Bank Swift Confirmation</h3>
      </div>
      <div class="scrollable">
        <div class="content-form bank-info">
          <p v-if="bankError">Error searching Banks. {{ bankErrorMsg }}</p>
          <p v-if="notFound">Intermediary Bank not found. Please check information and try again.</p>
          <template v-if="bankSwiftInfo">
            <div class="form-row form-split">
              <label>
                <b>Swift Code: </b>
              </label>
              <label>
                {{ bankSwiftInfo["routingNumber"] }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Name: </b>
              </label>
              <label>
                {{ bankSwiftInfo["bankName"] }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Address: </b>
              </label>
              <label>
                {{ bankSwiftAddress['line1'] }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Address 2: </b>
              </label>
              <label>
                {{ bankSwiftAddress['line2'] }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>City: </b>
              </label>
              <label>
                {{ bankSwiftAddress['city'] }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>State/Province: </b>
              </label>
              <label>
                {{ bankSwiftAddress['state'] }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Postal/Zip: </b>
              </label>
              <label>
                {{ bankSwiftAddress['postalCode'] }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Country: </b>
              </label>
              <label>
                {{ bankSwiftAddress['country'] }}
              </label>
            </div>
            <div class="form-row form-split">
              <label>
                <b>Phone: </b>
              </label>
              <label>

              </label>
            </div>
          </template>
        </div>
        <div class="buttons">
          <template v-if="notFound || bankError">
            <button class="second" @click="showSwiftConfirm = false">Close</button>
          </template>
          <template v-else>
            <button class="main" @click="confirmSwiftIntermediary()">Confirm</button>
            <button class="second" @click="showSwiftConfirm = false">Cancel</button>
          </template>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
import AddressForm from './Address'
import AddressDomForm from './AddressDom'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },

    v: {
      type: Object,
      required: true
    },

    hideBankAccountType: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AddressForm,
    AddressDomForm,
  },

  data () {
    return {
      form: this.value,

      accountOptions: [
        {
          id: 'personal',
          text: 'Personal Checking'
        },
        {
          id: 'business',
          text: 'Business Checking'
        }
      ],

      bankTypeOptions: [
        {
          id: 'checking',
          text: 'Checking'
        },
        {
          id: 'savings',
          text: 'Savings'
        }
      ],

      showBtn: false,
      showSwiftBtn: false,

      bankError: false,
      notFound: false,
      bankInfo: null,
      bankErrorMsg: null,
      bankAddress: null,
      showConfirm: false,

      bankSwiftInfo: null,
      bankSwiftAddress: null,
      showSwiftConfirm: false
    }
  },

  watch: {
    'form.intermediary_bank_routing_number' () {
      this.v.intermediary_bank_routing_number.$touch()
      if(!this.v.intermediary_bank_routing_number.$invalid) {
        this.showBtn = true
      }
    },

    'form.swift' () {
      this.v.swift.$touch()
      if(!this.v.swift.$invalid) {
        this.showSwiftBtn = true
      }
    },

    value: {
      handler () {
        this.form = this.value
      },
      deep: true,
      immediate: true
    },

    form: {
      handler (value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },

  methods: {
    async validateRoutingNumber() {
      const loader = this.$loading.show()
      let payload;
      payload = {
        type: 'bank_routing_number',
        value: this.form.intermediary_bank_routing_number,
        deposit_type: this.form.deposit_type,
      }
      const response = (await api.action("Transactions", "new", "Bank", payload))
      if(response.action.error){
        this.bankError = true
        this.bankErrorMsg = response.action.errors
        this.notFound = false
        this.bankInfo = null
        this.bankAddress = null
        this.showConfirm = true
        loader.hide()
      } else if(response.action.notFound){
        this.notFound = true
        this.bankError = false
        this.bankInfo = null
        this.bankAddress = null
        this.showConfirm = true
        loader.hide()
      }else{
        this.bankInfo = response.action.data
        this.bankAddress = response.action.address
        this.bankError = false
        this.notFound = false
        this.showConfirm = true
        loader.hide()
      }
    },

    async validateSwift() {
      const loader = this.$loading.show()
      let payload;
      payload = {
        type: 'swift',
        value: this.form.swift,
      }
      const response = (await api.action("Transactions", "new", "BankSwift", payload))
      if(response.action.error){
        this.bankError = true
        this.bankErrorMsg = response.action.errors
        this.notFound = false
        this.bankInfo = null
        this.bankAddress = null
        this.showConfirm = true
        loader.hide()
      } else if(response.action.notFound){
        this.notFound = true
        this.bankError = false
        this.bankInfo = null
        this.bankAddress = null
        this.showConfirm = true
        loader.hide()
      }else{
        this.bankSwiftInfo = response.action.data
        this.bankSwiftAddress = response.action.address
        this.bankError = false
        this.notFound = false
        this.showSwiftConfirm = true
        loader.hide()
      }
    },

    confirmIntermediary() {
      this.form.intermediary_address.country = this.bankInfo.country?  this.bankInfo.country : null
      this.form.intermediary_address.state = this.bankInfo.state
      this.form.intermediary_address.address = this.bankInfo.street
      this.form.intermediary_address.city = this.bankInfo.city
      this.form.intermediary_address.postal = this.bankInfo.zip
      this.form.intermediary_bank_name = this.bankInfo.name
      this.form.intermediary_address.disabled = false
      this.showConfirm = false
    },

    confirmSwiftIntermediary() {
      this.form.bank_name = this.bankSwiftInfo['bankName']
      this.form.bank_country = this.bankSwiftAddress['country']
      this.form.bank_address = this.bankSwiftAddress['line1']
      this.form.bank_city = this.bankSwiftAddress['city']
      this.form.bank_state = this.bankSwiftAddress['state']
      this.form.bank_postal = this.bankSwiftAddress['postalCode']
      this.showSwiftConfirm = false
    }
  },
}
</script>

<style lang="scss" scoped>
  .routing-number-validate {
    position: relative;

    .show-btn {
      position: absolute;
      left: 50%;
      width: 100px;
      height: 30px;
      font-size: 12px;
      font-weight: 400;
    }
  }

  .bank-info {
    label {
      width: 50%;
    }
  }

  .account-number-alert {
    margin-top: -15px !important;
    padding: 0 !important;
  }

  .use_intermediary_bank_div {
    display: flex;
    justify-content: space-between;
  }

  .center-checkbox {
    width: 50%;
  }
  .bank-name {
    margin-top: 0;
    font-size: 10px;
  }
</style>
